import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs'
import FileUploadActions from '../admin/organization/sections/FileUploadActions';
import AttachCommunityAnnualReport from './AttachCommunityAnnualReport'
import Modal from '../../ui/modal/Modal';
import DeleteAnnualReportFile from './DeleteAnnualReportFile'
import DonationsForm from './DonationsForm'
import axios from 'axios';
import Lock from './Lock';
var fileDownload = require('js-file-download');

const styles = {
    fileinput: {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
    },
    filelabel: {
        fontSize: '1em',
        fontWeight: 700,
        color: 'white',
        display: 'inline-block',
        padding: '.4em',
        margin: '0 0 .5em 0',
        cursor: 'pointer',
    },
    tablecellpadding: {
        padding: '1.5em 0',
    }
}

export default class AnnualReport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            accept: false,
            gdpr: false,
            currentAnnualReport: false,
            currentAnnualReportContent: this.props.currentAnnualReport,
            locked: false
        }
    }

    componentDidMount() {
            this.setState({
                currentAnnualReport: this.props.currentAnnualReportName,
                locked: this.props.currentAnnualReport.unlocked === 0
            });
    }

    handleUnLock = (documentType) => {
        this.setState({
            locked: false
        }, this.props.onHandleLockingDocument('unlock', documentType))
    }
    
    handleLock = (documentType) => {
        this.setState({
            locked: true
        }, this.props.onHandleLockingDocument('lock', documentType))
    }

    // @ToDo : removeAnnualReportFileFromState afvikles både i denne her og næste funktion. Er det nødvendigt?
    _handleDeleteAnnualReportFile = (e) => {
        e.preventDefault();
        this.setState({
            annualReportFile: null,
            currentAnnualReportContent: null,
            accept: false,
        });
        // Clear file values from state, so they won't get uploaded again
        this.removeAnnualReportFileFromState();
    }

    _handleDeleteAnnualReportFileFromServer = () => {
        this.setState({
            currentAnnualReport: false
        });
        // Clear file values from state, so they won't get uploaded again
        this.removeAnnualReportFileFromState();
        // After this we do the actual deleting from the server
        this.props.deleteDocumentFromServer(this.props.currentAnnualReport.id);
    }

    removeAnnualReportFileFromState = () => {
        this.props.onHandleFileDelete('annualReport');
    }

    _onHandleDownloadFile = (id, filename) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token, 'Content-Type' : 'application/pdf'};
        const url = APP_URL_API + 'files/' + id + '/download';

        this.serverRequest =
            axios
                .get(url, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                    fileDownload(response.data, filename);
                })
    }

    _onAttachCommunityAnnualReportHideBtn = () => {
        this.setState({
            currentAnnualReport: true
        })
    }

    onHandleApproveDocument = (documentId) => {
        this.setState({
            locked: true
        });
        this.props.onHandleApproveDocument(documentId);
    }
    
    onHandleRejectDocument = (documentId) => {
        this.setState({
            locked: false
        });
        this.props.onHandleRejectDocument(documentId);
    }

    render() {
        const advancedInterface = this.props.advancedInterface;
        const locked = advancedInterface ? this.state.locked : this.props.locked;
        const handleUnlock = advancedInterface ? (documentType) => this.handleUnLock(documentType) : (documentType) => this.props.handleUnLock(documentType);
        const { 
            currentAnnualReportInherited,
            donationWaitingForApproval,
            annualReportWaitingForApproval 
        } = this.props;
        let showIcons = true;
        if(currentAnnualReportInherited) {
            showIcons = false;
        }
        if(annualReportWaitingForApproval != "") {
            showIcons = false;
        }

        return(
            <div className="flex gap-4 items-center flex-1 shrink px-4">
                <div className="flex flex-col gap-4">
                {this.state.currentAnnualReport ?
                    <div className="flex flex-col gap-4">
                        <div className="flex gap-4 items-center">
                            <CurrentAnnualReport 
                                currentAnnualReportName={this.props.currentAnnualReportName} 
                                currentAnnualReportInherited={currentAnnualReportInherited}
                                currentAnnualReportId={this.props.currentAnnualReport.id}
                                onHandleDownloadFile={this._onHandleDownloadFile}
                            />
                            
                            {showIcons && <div>
                                <Lock 
                                    user={this.props.user} 
                                    locked={locked}
                                    handleUnLock={this.handleUnLock}
                                    handleLock={(documentType) => this.handleLock(documentType)}
                                    advancedInterface={advancedInterface}
                                    documentType="annualReport"
                                />
                            
                                <DeleteAnnualReportFile
                                    user={this.props.user}
                                    currentAnnualReport={this.state.currentAnnualReport}
                                    currentAnnualReportInherited={this.props.currentAnnualReportInherited}
                                    _handleDeleteAnnualReportFile={this._handleDeleteAnnualReportFile}
                                    _handleDeleteAnnualReportFileFromServer={this._handleDeleteAnnualReportFileFromServer}
                                    file={this.props.annualReportFile}
                                />
                            </div>
                            }
                        
                        </div>

                        {annualReportWaitingForApproval && <WaitingForApproval 
                                year={this.props.year} 
                                document={annualReportWaitingForApproval}
                                document1={donationWaitingForApproval}
                                advancedInterface={advancedInterface}
                                onHandleDownloadFile={this._onHandleDownloadFile}
                                onHandleApproveDocument={this.onHandleApproveDocument}
                                onHandleRejectDocument={this.onHandleRejectDocument}
                                user={this.props.user} />
                            }
                    
                        {!locked && !this.props.annualReportWaitingForApproval && !currentAnnualReportInherited &&
                            <div>
                                <FileUploadActions
                                    file={this.props.annualReportFile}
                                    onToggleModal={this.props.onToggleModal}
                                    label="Indberet årsregnskab" />
                            </div>
                        }
                    </div>
                :
                    <FileUploadActions
                        file={this.props.annualReportFile}
                        onToggleModal={this.props.onToggleModal}
                        label="Indberet årsregnskab" />
                }

                {this.props.organizationType==="congregation" &&
                    <AttachCommunityAnnualReport
                        annualReportCommunity={this.props.annualReportCommunity}
                        donationCommunity={this.props.donationCommunity}
                        advancedInterface={advancedInterface}
                        annualReportFile={this.props.annualReportFile}
                        user={this.props.user}
                        organizationType={this.props.organizationType}
                        currentAnnualReportInherited={this.props.currentAnnualReportInherited}
                        currentAnnualReport={this.state.currentAnnualReport}
                        onAttachCommunityAnnualReportHideBtn={this._onAttachCommunityAnnualReportHideBtn}
                        onDetachCommunityAnnualReport={this.props.onDetachCommunityAnnualReport}
                        onAttachCommunityAnnualReport={this.props.onAttachCommunityAnnualReport} />
                }
                </div>

            <Modal visible={this.props.showModal}>
                <h4>Årsregnskab {this.props.year}</h4>
                <div style={{margin: '1.5em 0'}}>
                    <input style={styles.fileinput} id={this.props.year + "_annualreport"} type="file" name="annualReportFile" onChange={this.props.onChange} ref={this.props.inputRef1} />
                    <label htmlFor={this.props.year + "_annualreport"} style={styles.filelabel} className="upload">{this.props.annualReportFile ? this.props.annualReportFile.name : 'Vælg årsregnskab'}</label>
                    <div className="form-helper-label">Kun PDF-filer på max 20 MB tilladt.</div>
                </div>
                {this.props.user.type==="user" && <div style={{marginTop: '1em'}}>
                    <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                    <input type="checkbox" name="accept" onChange={this.props.onChange} checked={this.props.accept} />
                    Jeg erklærer hermed på tro og love, at de indberettede oplysninger er korrekte og i overensstemmelse med de gældende regler for anerkendte trossamfund, samt at jeg i henhold til § 7, stk. 2, nr. 4, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken er berettiget til på trossamfundets/menighedens vegne at foretage indberetningen.
                    </label>
                    <p>By-, Land- og Kirkeministeriet gør opmærksom på, at de indberettede oplysninger vises på Trossamfundsregistrets hjemmeside, jf. § 21, stk. 1 og 2, jf. § 11, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken.</p>
                </div>}
                {this.props.user.type==="admin" &&
                    <div style={{marginTop: '1em'}}>
                        Der foreligger dokumentation i ESDH-systemet for, at trossamfundet/menigheden har anmodet By-, Land- og Kirkeministeriet om at indberette på trossamfundets/menighedens vegne.
                    </div>
                }

                {!this.props.advancedInterface &&  
                    <DonationsForm
                        onChange={this.props.onChange}
                        donations={this.props.donations}
                        user={this.props.user}
                        inputRef={this.props.inputRef2}
                    />
                }
            
                <div style={{marginTop: '1em'}}>
                    <button type="button" className="button" onClick={this.props.onCloseModal}>Luk</button>
                    <button type="button" className="button" onClick={(e) => this.props.onSubmit(e)}>Gem</button>
                </div>
            </Modal>
            
            <Modal visible={this.props.showAlertModal}>
                <p>{this.props.modalText}</p>
                <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                    <button type="button" className="button" onClick={this.props.closeAlertModal}>Ok</button>
                </div>
            </Modal>
        </div>
        )
    }
}

const WaitingForApproval = (props) => {
    const approveMessage = props.advancedInterface || !props.document1 ? 'Er du sikker på at du vil godkende årsregnskabet?' : 'Er du sikker på at du vil godkende årsregnskabet og bilag vedr. donationer?';
    const rejectMessage = props.advancedInterface || !props.document1 ? 'Hvis du afviser bliver filen slettet permanent' : 'Hvis du afviser bliver filerne slettet permanent';
    if(props.document) {
    return (
        <div className="approvalPanel approvalPanel--small">
            <div style={{fontSize: '12px'}}>Afventer godkendelse</div>
            <div style={{cursor: 'pointer'}} onClick={() => props.onHandleDownloadFile(props.document.id, props.document.filename)}>{props.document.filename}</div>
            <div style={{cursor: 'pointer'}} onClick={() => props.onHandleDownloadFile(props.document1.id, props.document1.filename)}>{props.document1.filename}</div>
            {props.user.type === 'admin' && 
            <div className="flex gap-2 pt-1">
                <img src="/images/assets/vhvid.svg" alt="Godkend"
                    onClick={() => { if (window.confirm(approveMessage)) props.onHandleApproveDocument(props.document.id) }} style={{cursor: 'pointer'}} />
                <img src="/images/assets/krydshvid.svg" alt="Afvis"
                    onClick={() => { if (window.confirm(rejectMessage)) props.onHandleRejectDocument(props.document.id) }} style={{cursor: 'pointer'}} />    
            </div>
            }
        </div>
    );
    } else {
        return null;
    }
}

const CurrentAnnualReport = (props) => {
    return (
        <div style={{cursor: 'pointer'}} onClick={() => props.onHandleDownloadFile(props.currentAnnualReportId, props.currentAnnualReportName)}>
            {props.currentAnnualReportName}
            {props.currentAnnualReportInherited && <span style={{fontSize: '0.8em'}}> (Tilknyttet)</span>}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/modules/reports/AnnualReport.js